/* tslint:disable */
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Content } from '../../atoms/Content/index'
import { Hcp11aView } from '../../organisms/HCP1-1a/HCP1_1a_View'
import { IntakeProgressBar } from '../../molecules/IntakeProgressBar'
import { Layout } from '../../atoms/Layout'
import { Nav } from '../../atoms/Nav'
import { OccupationNavBar } from '../../molecules/OccupationNavBar'
import { ProfileDropdown } from '../../organisms/ProfileDropdown'
import {
  intakeMetrics
} from '../../organisms/Intakes/intakeMetrics/calcIntakeMetrics'
import { media } from '../../utils/media'
import MenuStore from '../../stores/MenuStore'
import MobileMenu from '../../atoms/MobileMenu'
import { withRouter } from 'react-router'

export const HCP1_1A = withRouter((props) => {
  const menuStore = MenuStore.create({})

  const intake = JSON.parse(localStorage.getItem('patientIntake'))
  const {
    surgeryOptions
  } = intakeMetrics(intake)

  let countNumber = 7

  if (surgeryOptions === 'P' || surgeryOptions === 'PM') {
    countNumber = 7
  } else {
    countNumber = 6
  }

  console.log('surgeryOptions', surgeryOptions)

  return (
    <Layout>
      <Nav.BarTips>
        <Nav.HomeButtonTips showHamburger={false} />
        <ProfileDropdown color={null} />
      </Nav.BarTips>
      <MobileMenu store={menuStore} />
      <OccupationNavBar className='no-print'>
        <Link to='/HCP1-patientInfo' style={{ textDecoration: 'none' }}><H2 active>Patient Info</H2></Link>
        <Link to='/contents/HCP1-1a' style={{ textDecoration: 'none' }}><H2 active={false}>Desired Behaviors</H2></Link>
        <Link to='/contents/HCP1-2' style={{ textDecoration: 'none' }}><H2 active={false}>Undesired Behaviors</H2></Link>
        <Link to='/contents/HCP1-3' style={{ textDecoration: 'none' }}><H2 active={false}>Conditional Behaviors</H2></Link>
        <Link to='/contents/HCP1-4' style={{ textDecoration: 'none' }}><H2 active={false}>Summary</H2></Link>
      </OccupationNavBar>
      <div className='print-header' />
      <Content style={{ marginTop: 100 }}>
        <Hcp11aView />
        <IntakeProgressBar
          count={countNumber}
          currentIndex={0}
          goToNext={() => {
            props.history.push('/contents/HCP1-1a')
          }}
          goToPrev={null} />
      </Content>
    </Layout>
  )
})

const H1 = styled.h1`
  font-family: Nunito;
  font-weight: 900;
  font-size: 45px;
  color: #12385b;

  ${media.tablet`
    font-size: 54px;
  `}
`

const H2 = styled.div`
  font-family: Nunito;
  font-size: 18px;
  font-weight: 900;
  color: ${({ active }) => active ? '#FC9426' : '#AEBFCC'};
  margin: 24px 25px;

  ${media.tablet`
    font-size: 22px;
  `}
`



// WEBPACK FOOTER //
// ./src/pages/HCP1-patientInfo/index.js